export const TOPICS_WIDGET_ID = 'topics-widget';
export const REVIEWS_WIDGET_ID = 'reviews-widget';
export const SENTIMENT_WIDGET_ID = 'sentiment-widget';
export const TREND_SENTIMENT_WIDGET_ID = 'trend-sentiment-widget';
export const DEMOGRAPHICS_WIDGET_ID = 'demographics-widget';
export const IMPACT_SCORE_WIDGET_ID = 'impact-score-widget';
export const KEYWORDS_CLOUD_WIDGET_ID = 'keywords-cloud-widget';
export const FIRST_REPLY_TIME_WIDGET_ID = 'first-reply-time-widget';
export const NETWORK_BREAKDOWN_WIDGET_ID = 'network-breakdown-widget';
export const TRENDING_KEYWORDS_WIDGET_ID = 'trending-keywords-widget';
export const CONVERSATION_THEMES_ID = 'conversation-themes-widget';
export const TRENDING_LABELS_WIDGET_ID = 'trending-label-widget';
export const MOST_IMPACTFUL_POSTS_WIDGET_ID = 'most-impactful-posts-widget';
export const CONVERSATION_CLUSER_WIDGET_ID = 'conversation-cluster-widget';
